module.exports = __webpack_public_path__ + "static/img/num.cd5a47ab.webp";